import { render } from "./WordAnalysis.vue?vue&type=template&id=d6b5bc4e&ts=true"
import script from "./WordAnalysis.vue?vue&type=script&lang=ts"
export * from "./WordAnalysis.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__